window.bundleDataL = {
"Lacy-girl": {
displayName: "Lacy",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lacy Personalized Coloring Experience",
variantId: "49971432259821",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lacy_final_cover.png?v=1775415513",
price: "$14.99",
preorder: true
},
{
title: "Lacy Unicorn Holographic Sticker",
variantId: "49945853853933",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lacy_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Lacy Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Lainey-girl": {
displayName: "Lainey",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lainey Personalized Coloring Experience",
variantId: "49754376765677",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lainey_final_cover.png?v=1775322362",
price: "$14.99",
preorder: true
},
{
title: "Lainey Unicorn Holographic Sticker",
variantId: "49933752991981",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lainey_holographic_sticker.png?v=1780099052",
price: "$4.99",
preorder: false
},
{
title: "Lainey Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Landon-boy": {
displayName: "Landon",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Landon Personalized Coloring Experience",
variantId: "49402627850477",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/LANDONFINALCOVER.png?v=1771816531",
price: "$14.99",
preorder: true
},
{
title: "Landon Dragon Holographic Sticker",
variantId: "49933768753389",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Landon_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Landon Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Lara-girl": {
displayName: "Lara",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lara Personalized Coloring Experience",
variantId: "49571395207405",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lara_final_cover.png?v=1773281880",
price: "$14.99",
preorder: true
},
{
title: "Lara Unicorn Holographic Sticker",
variantId: "49933757219053",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lara_holographic_sticker.png?v=1780099052",
price: "$4.99",
preorder: false
},
{
title: "Lara Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Laura-girl": {
displayName: "Laura",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Laura Personalized Coloring Experience",
variantId: "49571496165613",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Laura_final_cover.png?v=1773281878",
price: "$14.99",
preorder: true
},
{
title: "Laura Unicorn Holographic Sticker",
variantId: "49933756891373",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Laura_holographic_sticker.png?v=1780099052",
price: "$4.99",
preorder: false
},
{
title: "Laura Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Lauren-girl": {
displayName: "Lauren",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lauren Personalized Coloring Experience",
variantId: "49274665566445",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/LaurenWillowmerefinalcover.png?v=1777994214",
price: "$14.99",
preorder: true
},
{
title: "Lauren Unicorn Holographic Sticker",
variantId: "49933780549869",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lauren_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Lauren Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Layla-girl": {
displayName: "Layla",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Layla Personalized Coloring Experience",
variantId: "49571462512877",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Laylafinalfinalcover.png?v=1773355448",
price: "$14.99",
preorder: true
},
{
title: "Layla Unicorn Holographic Sticker",
variantId: "49933757120749",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Layla_holographic_sticker.png?v=1780099052",
price: "$4.99",
preorder: false
},
{
title: "Layla Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Leah-girl": {
displayName: "Leah",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Leah Personalized Coloring Experience",
variantId: "49279570018541",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Leah_final_cover.png?v=1773766534",
price: "$14.99",
preorder: true
},
{
title: "Leah Unicorn Holographic Sticker",
variantId: "49933775274221",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Leah_holographic_sticker.png?v=1780099049",
price: "$4.99",
preorder: false
},
{
title: "Leah Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Leila-girl": {
displayName: "Leila",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Leila Personalized Coloring Experience",
variantId: "49279570149613",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Leilafinalfinalcover_6a710d7d-ef13-4f18-bedc-1a63023476c1.png?v=1773331467",
price: "$14.99",
preorder: true
},
{
title: "Leila Unicorn Holographic Sticker",
variantId: "49933775241453",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Leila_holographic_sticker.png?v=1780099052",
price: "$4.99",
preorder: false
},
{
title: "Leila Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Leilani-girl": {
displayName: "Leilani",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Leilani Personalized Coloring Experience",
variantId: "49571526541549",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Leilani_final_cover.png?v=1773281881",
price: "$14.99",
preorder: true
},
{
title: "Leilani Unicorn Holographic Sticker",
variantId: "49933756760301",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Leilani_holographic_sticker.png?v=1780099052",
price: "$4.99",
preorder: false
},
{
title: "Leilani Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Lena-girl": {
displayName: "Lena",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lena Personalized Coloring Experience",
variantId: "49571398648045",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lena_final_cover.png?v=1773281878",
price: "$14.99",
preorder: true
},
{
title: "Lena Unicorn Holographic Sticker",
variantId: "49933757186285",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lena_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Lena Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Leo-boy": {
displayName: "Leo",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Leo Personalized Coloring Experience",
variantId: "49402631651565",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/LEOFINALCOVER.png?v=1771816669",
price: "$14.99",
preorder: true
},
{
title: "Leo Dragon Holographic Sticker",
variantId: "49933768720621",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Leo_holographic_sticker.png?v=1779648213",
price: "$4.99",
preorder: false
},
{
title: "Leo Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Leon-boy": {
displayName: "Leon",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Leon Personalized Coloring Experience",
variantId: "49402650427629",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/LEONFINALCOVER.png?v=1771817134",
price: "$14.99",
preorder: true
},
{
title: "Leon Dragon Holographic Sticker",
variantId: "49933768655085",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Leon_holographic_sticker.png?v=1779648208",
price: "$4.99",
preorder: false
},
{
title: "Leon Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Leonardo-boy": {
displayName: "Leonardo",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Leonardo Personalized Coloring Experience",
variantId: "49397448638701",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Leonardofinalcover.png?v=1771597880",
price: "$14.99",
preorder: true
},
{
title: "Leonardo Dragon Holographic Sticker",
variantId: "49933770359021",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Leonardo_sticker.png?v=1779648210",
price: "$4.99",
preorder: false
},
{
title: "Leonardo Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Levi-boy": {
displayName: "Levi",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Levi Personalized Coloring Experience",
variantId: "49279570247917",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Levifinalcover.png?v=1772682793",
price: "$14.99",
preorder: true
},
{
title: "Levi Dragon Holographic Sticker",
variantId: "49933775208685",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Levi_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Levi Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Liam-boy": {
displayName: "Liam",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Liam Personalized Coloring Experience",
variantId: "49279570313453",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Liamfinalcover.png?v=1772681314",
price: "$14.99",
preorder: true
},
{
title: "Liam Dragon Holographic Sticker",
variantId: "49933775143149",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Liam_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Liam Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Lila-girl": {
displayName: "Lila",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lila Personalized Coloring Experience",
variantId: "49774111162605",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lila_final_cover.png?v=1775415296",
price: "$14.99",
preorder: true
},
{
title: "Lila Unicorn Holographic Sticker",
variantId: "49933752828141",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lila_holographic_sticker.png?v=1780099049",
price: "$4.99",
preorder: false
},
{
title: "Lila Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Liliana-girl": {
displayName: "Liliana",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Liliana Personalized Coloring Experience",
variantId: "49571464315117",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Liliana_final_cover.png?v=1773281880",
price: "$14.99",
preorder: true
},
{
title: "Liliana Unicorn Holographic Sticker",
variantId: "49933757087981",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Liliana_holographic_sticker.png?v=1780099049",
price: "$4.99",
preorder: false
},
{
title: "Liliana Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Lillian-girl": {
displayName: "Lillian",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lillian Personalized Coloring Experience",
variantId: "49571500294381",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lillian_final_cover.png?v=1773281880",
price: "$14.99",
preorder: true
},
{
title: "Lillian Unicorn Holographic Sticker",
variantId: "49933756858605",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lillian_holographic_sticker.png?v=1780099052",
price: "$4.99",
preorder: false
},
{
title: "Lillian Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Lily-girl": {
displayName: "Lily",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lily Personalized Coloring Experience",
variantId: "49571544367341",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lily_final_final_cover.png?v=1773359989",
price: "$14.99",
preorder: true
},
{
title: "Lily Unicorn Holographic Sticker",
variantId: "49933756727533",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lily_holographic_sticker.png?v=1780099048",
price: "$4.99",
preorder: false
},
{
title: "Lily Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Lincoln-boy": {
displayName: "Lincoln",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lincoln Personalized Coloring Experience",
variantId: "49402652623085",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/LINCOLNFINALCOVER.png?v=1771817296",
price: "$14.99",
preorder: true
},
{
title: "Lincoln Dragon Holographic Sticker",
variantId: "49933768589549",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lincoln_holographic_sticker.png?v=1779648211",
price: "$4.99",
preorder: false
},
{
title: "Lincoln Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Linnea-girl": {
displayName: "Linnea",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Linnea Personalized Coloring Experience",
variantId: "49274519027949",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Linnea_final_cover.png?v=1773766532",
price: "$14.99",
preorder: true
},
{
title: "Linnea Unicorn Holographic Sticker",
variantId: "49933780680941",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Linnea_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Linnea Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Livie-girl": {
displayName: "Livie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Livie Personalized Coloring Experience",
variantId: "49929639756013",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Livie_final_cover.png?v=1777857547",
price: "$14.99",
preorder: true
},
{
title: "Livie Unicorn Holographic Sticker",
variantId: "49933746012397",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Livie_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Livie Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Logan-boy": {
displayName: "Logan",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Logan Personalized Coloring Experience",
variantId: "49279570378989",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Loganfinalcover.png?v=1772674454",
price: "$14.99",
preorder: true
},
{
title: "Logan Dragon Holographic Sticker",
variantId: "49933775077613",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Logan_holographic_sticker.png?v=1779648213",
price: "$4.99",
preorder: false
},
{
title: "Logan Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Lorenzo-boy": {
displayName: "Lorenzo",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lorenzo Personalized Coloring Experience",
variantId: "49279570477293",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lorenzofinalcover.png?v=1772677938",
price: "$14.99",
preorder: true
},
{
title: "Lorenzo Dragon Holographic Sticker",
variantId: "49933775012077",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lorenzo_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Lorenzo Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Lottie-girl": {
displayName: "Lottie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lottie Personalized Coloring Experience",
variantId: "49471970115821",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lottie_final_cover_0f96ac6a-948b-46bd-887c-03f8db0b9f69.png?v=1772908493",
price: "$14.99",
preorder: true
},
{
title: "Lottie Unicorn Holographic Sticker",
variantId: "49933759217901",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lottie_holographic_sticker.png?v=1780099051",
price: "$4.99",
preorder: false
},
{
title: "Lottie Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Luca-boy": {
displayName: "Luca",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Luca Personalized Coloring Experience",
variantId: "49402655670509",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/LUCAFINALCOVER.png?v=1771817510",
price: "$14.99",
preorder: true
},
{
title: "Luca Dragon Holographic Sticker",
variantId: "49933768556781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Luca_holographic_sticker.png?v=1779648202",
price: "$4.99",
preorder: false
},
{
title: "Luca Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Lucas-boy": {
displayName: "Lucas",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lucas Personalized Coloring Experience",
variantId: "49279570575597",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lucasfinalcover.png?v=1772675406",
price: "$14.99",
preorder: true
},
{
title: "Lucas Dragon Holographic Sticker",
variantId: "49933774913773",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lucas_holographic_sticker.png?v=1779648212",
price: "$4.99",
preorder: false
},
{
title: "Lucas Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Lucia-girl": {
displayName: "Lucia",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lucia Personalized Coloring Experience",
variantId: "49471777997037",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lucia_final_cover.png?v=1772908491",
price: "$14.99",
preorder: true
},
{
title: "Lucia Unicorn Holographic Sticker",
variantId: "49933759480045",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lucia_holographic_sticker.png?v=1780099045",
price: "$4.99",
preorder: false
},
{
title: "Lucia Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Lucifer-boy": {
displayName: "Lucifer",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lucifer Personalized Coloring Experience",
variantId: "49731784802541",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lucifer_final_cover.png?v=1774739906",
price: "$14.99",
preorder: true
},
{
title: "Lucifer Dragon Holographic Sticker",
variantId: "49933753581805",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lucifer_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Lucifer Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Lucius-boy": {
displayName: "Lucius",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lucius Personalized Coloring Experience",
variantId: "49731855417581",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lucius_final_cover.png?v=1774739906",
price: "$14.99",
preorder: true
},
{
title: "Lucius Dragon Holographic Sticker",
variantId: "49933753549037",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lucius_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Lucius Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Lucy-girl": {
displayName: "Lucy",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lucy Personalized Coloring Experience",
variantId: "49577602187501",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lucy_final_cover.png?v=1773369576",
price: "$14.99",
preorder: true
},
{
title: "Lucy Unicorn Holographic Sticker",
variantId: "49933756596461",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lucy_holographic_sticker.png?v=1780099048",
price: "$4.99",
preorder: false
},
{
title: "Lucy Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Luis-boy": {
displayName: "Luis",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Luis Personalized Coloring Experience",
variantId: "49402661175533",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/LUISFINALCOVER.png?v=1771817670",
price: "$14.99",
preorder: true
},
{
title: "Luis Dragon Holographic Sticker",
variantId: "49933768524013",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Luis_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Luis Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Luke-boy": {
displayName: "Luke",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Luke Personalized Coloring Experience",
variantId: "49402664288493",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/LUKEFINALCOVER.png?v=1771817830",
price: "$14.99",
preorder: true
},
{
title: "Luke Dragon Holographic Sticker",
variantId: "49933768491245",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Luke_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Luke Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Luna-girl": {
displayName: "Luna",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Luna Personalized Coloring Experience",
variantId: "49279570673901",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Luna_final_cover.png?v=1773766537",
price: "$14.99",
preorder: true
},
{
title: "Luna Unicorn Holographic Sticker",
variantId: "49933774848237",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Luna_holographic_sticker.png?v=1780099051",
price: "$4.99",
preorder: false
},
{
title: "Luna Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Lydia-girl": {
displayName: "Lydia",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lydia Personalized Coloring Experience",
variantId: "49577152119021",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lydia_final_cover.png?v=1773369576",
price: "$14.99",
preorder: true
},
{
title: "Lydia Unicorn Holographic Sticker",
variantId: "49933756694765",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lydia_holographic_sticker.png?v=1780099049",
price: "$4.99",
preorder: false
},
{
title: "Lydia Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,"Lynn-girl": {
displayName: "Lynn",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lynn Personalized Coloring Experience",
variantId: "49579852071149",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lynn_final_cover.png?v=1773369575",
price: "$14.99",
preorder: true
},
{
title: "Lynn Unicorn Holographic Sticker",
variantId: "49933756432621",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lynn_holographic_sticker.png?v=1780099051",
price: "$4.99",
preorder: false
},
{
title: "Lynn Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Lacey-girl": {
displayName: "Lacey",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lacey Personalized Coloring Experience",
variantId: "50042187186413",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lacey_final_cover_8bf8af0d-dfde-47c2-8643-1542e732cfee.png?v=1780107424",
price: "$14.99",
preorder: true
},
{
title: "Lacey Unicorn Holographic Sticker",
variantId: "50042133971181",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lacey_holographic_sticker.png?v=1780099045",
price: "$4.99",
preorder: false
},
{
title: "Lacey Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Lyla-girl": {
displayName: "Lyla",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lyla Personalized Coloring Experience",
variantId: "50056816034029",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lyla_final_cover.png?v=1780209146",
price: "$14.99",
preorder: true
},
{
title: "Lyla Unicorn Holographic Sticker",
variantId: "50056840380653",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lyla_holographic_sticker.png?v=1780206654",
price: "$4.99",
preorder: false
},
{
title: "Lyla Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Luka-boy": {
displayName: "Luka",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Luka Personalized Coloring Experience",
variantId: "50126014709997",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Luka_final_cover.png?v=1781929666",
price: "$14.99",
preorder: true
},
{
title: "Luka Dragon Holographic Sticker",
variantId: "50127073083629",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lukastickerwebsite.png?v=1781967701",
price: "$4.99",
preorder: false
},
{
title: "Luka Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Legend-boy": {
displayName: "Legend",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Legend Personalized Coloring Experience",
variantId: "50126147813613",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Legend_final_cover.png?v=1781929666",
price: "$14.99",
preorder: true
},
{
title: "Legend Dragon Holographic Sticker",
variantId: "50127071477997",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Legendstickerwebsite.png?v=1781967600",
price: "$4.99",
preorder: false
},
{
title: "Legend Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Lukas-boy": {
displayName: "Lukas",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lukas Personalized Coloring Experience",
variantId: "50399773032685",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lukasfinalcover.png?v=1785904498",
price: "$14.99",
preorder: true
},
{
title: "Lukas Dragon Holographic Sticker",
variantId: "50449505321197",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lukas_holographic_sticker.png?v=1786244665",
price: "$4.99",
preorder: false
},
{
title: "Lukas Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Louis-boy": {
displayName: "Louis",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Louis Personalized Coloring Experience",
variantId: "50399836504301",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Louisfinalcover.png?v=1785905846",
price: "$14.99",
preorder: true
},
{
title: "Louis Dragon Holographic Sticker",
variantId: "50449520984301",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Louis_holographic_sticker.png?v=1786244664",
price: "$4.99",
preorder: false
},
{
title: "Louis Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Lane-boy": {
displayName: "Lane",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lane Personalized Coloring Experience",
variantId: "50449682497773",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lane_final_cover.png?v=1786244941",
price: "$14.99",
preorder: true
},
{
title: "Lane Dragon Holographic Sticker",
variantId: "50449575248109",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lane_holographic_sticker.png?v=1786244664",
price: "$4.99",
preorder: false
},
{
title: "Lane Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Lennox-boy": {
displayName: "Lennox",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lennox Personalized Coloring Experience",
variantId: "50457731662061",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lennox_final_cover.png?v=1786406747",
price: "$14.99",
preorder: true
},
{
title: "Lennox Dragon Holographic Sticker",
variantId: "50457702170861",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lennox_holographic_sticker.png?v=1786406786",
price: "$4.99",
preorder: false
},
{
title: "Lennox Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Lilah-girl": {
displayName: "Lilah",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lilah Personalized Coloring Experience",
variantId: "50519281139949",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lilah_final_cover.png?v=1786941539",
price: "$14.99",
preorder: true
},
{
title: "Lilah Unicorn Holographic Sticker",
variantId: "50497551958253",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lilah_holographic_sticker.png?v=1787505458",
price: "$4.99",
preorder: false
},
{
title: "Lilah Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Londyn-girl": {
displayName: "Londyn",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Londyn Personalized Coloring Experience",
variantId: "50594989998317",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Londynfinalcover.png?v=1788158481",
price: "$14.99",
preorder: true
},
{
title: "Londyn Unicorn Holographic Sticker",
variantId: "50604077220077",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Londyn_holographic_sticker.png?v=1788224572",
price: "$4.99",
preorder: false
},
{
title: "Londyn Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Lilly-girl": {
displayName: "Lilly",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lilly Personalized Coloring Experience",
variantId: "50595160031469",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lillyfinalcover.png?v=1788160194",
price: "$14.99",
preorder: true
},
{
title: "Lilly Unicorn Holographic Sticker",
variantId: "50604077547757",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lilly_holographic_sticker.png?v=1788224571",
price: "$4.99",
preorder: false
},
{
title: "Lilly Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Lia-girl": {
displayName: "Lia",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Lia Personalized Coloring Experience",
variantId: "50594832646381",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lia_final_cover.png?v=1788157251",
price: "$14.99",
preorder: true
},
{
title: "Lia Unicorn Holographic Sticker",
variantId: "50604077940973",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Lia_holographic_sticker.png?v=1788224572",
price: "$4.99",
preorder: false
},
{
title: "Lia Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} 














};